import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import burgerImg from "../../media/images/filters/burger.webp";
import italianImg from "../../media/images/filters/italian.webp";
import dessertImg from "../../media/images/filters/dessert.webp";
import drinkrImg from "../../media/images/filters/drink.webp";

const SplashScreen = (props) => {
  const { height = "100vh", loadingScreen, className, loaderOnly } = props;
  const { restaurantConfig } = useSelector((state) => state.config);
  const [aspectRatio, setaspectRatio] = useState(null);

  useEffect(() => {
    if (restaurantConfig && restaurantConfig.companyLogo) {
      var img = new Image();

      // Set the src attribute to the image URL
      img.src = restaurantConfig.companyLogo;

      // When the image has loaded, calculate the aspect ratio
      img.onload = function () {
        // Get width and height of the image
        var width = img.naturalWidth;
        var height = img.naturalHeight;

        // Calculate aspect ratio
        var aspectRatio = width / height;
        setaspectRatio(aspectRatio);

        // Log the aspect ratio
      };

      // If there's an error loading the image
      img.onerror = function () {
        console.error("Error loading image");
      };
    }
  }, [restaurantConfig]);

  if (!restaurantConfig || !aspectRatio || loaderOnly) {
    return (
      <div className={`splash-screen ${loadingScreen ? "loading-screen" : ""} ${className}`} style={{ height }}>
        <div className="loader">
          <div className="loader bl">
            <img src={burgerImg} alt="burger" />
          </div>
          <div className="loader tr">
            <img src={italianImg} alt="italian" />
          </div>
          <div className="loader br">
            <img src={dessertImg} alt="dessert" />
          </div>
          <div className="loader tl">
            <img src={drinkrImg} alt="drink" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`splash-screen ${loadingScreen ? "loading-screen" : ""} ${className}`} style={{ height }}>
      {restaurantConfig.companyLogo && (
        <div className="logo" style={{ width: "20rem", height: `${20 / aspectRatio}rem` }}>
          <img src={restaurantConfig.companyLogo} alt={restaurantConfig.companyName} />
        </div>
      )}
      <CircularProgress color="secondary" size="2.5rem" />
    </div>
  );
};

export default SplashScreen;
